import type { FeatureFlag } from '~/plugins/featureFlags';

export const useIsFeatureEnabled = (featureName: FeatureFlag) => {
	const isFeatureFlagEnabled = computed(() => {
		const feature = useNuxtApp().$featureFlags.features.get(featureName);

		if (typeof feature !== 'boolean') {
			return false;
		}

		return feature;
	});

	return isFeatureFlagEnabled;
};
